import React, { Component } from 'react';
import SelectForm from './forminput/selectform';
import TableForm from './forminput/tableform';
import LiteralForm from './forminput/literalform';
import InputNumberForm from './forminput/inputnumberform';
import InputTextForm from './forminput/inputtextform';
import DatePickerForm from './forminput/datepickerform';
import TextAreaForm from './forminput/textareaform';
import CheckBoxForm from './forminput/checkbox';
import RadioForm from './forminput/radioform';
import SelectSercheableForm from './forminput/selectsercheableform';

class InputForm extends Component {
    state = {
        domain: "",
        title: "",
        type: "",
        size: "",
        mode: "",
        line: "",
        width: "",
        offset: "",
        visiblerows: "",
        minlength: "",
        maxlength: "",
        disabled: "",
        hidden: "",
        align: "",
        values: [],
        defaultValue: 0,
        table_data: [],
        showLabel: true,
        rowIndex: -1,
        minWords: null,    
        rowIndex: -1
    }

    constructor(props) {
        super(props);

        var elementForm = props.dataJson[props.elementForm];
        if (props.showLabel === false) {
            this.state.showLabel = props.showLabel;
        }
        if (props.rowIndex >= 0) {
            this.state.rowIndex = props.rowIndex;
        }
        var dataKeys = Object.keys(elementForm);
        const validPropsJson = ['ishtml'];
        const validPropsJs = ['isHtml'];
        for (var i = 0; i < dataKeys.length; i++) {
            let foundMappeableProp = -1;
            var field = dataKeys[i];
            const lowerCaseField = field.toLowerCase();
            var value = elementForm[field];
            if (field.toLowerCase() === 'domain') {
                this.state.domain = value;
            } else if (field.toLowerCase() === 'text') {
                this.state.text = value;
            } else if (field.toLowerCase() === 'type') {
                this.state.type = value;
            } else if (field.toLowerCase() === 'size') {
                this.state.size = value;
            } else if (field.toLowerCase() === 'mode') {
                this.state.mode = value;
            } else if (field.toLowerCase() === 'line') {
                this.state.line = value;
            } else if (field.toLowerCase() === 'width') {
                this.state.width = value;
            } else if (field.toLowerCase() === 'offset') {
                this.state.offset = value;
            } else if (field.toLowerCase() === 'defaultvalue') {
                this.state.defaultValue = value;
            } else if (field.toLowerCase() === 'visiblerows') {
                this.state.visiblerows = value;
            } else if (field.toLowerCase() === 'minlength') {
                this.state.minlength = value;
            } else if (field.toLowerCase() === 'maxlength') {
                this.state.maxlength = value;
            } else if (field.toLowerCase() === 'disabled') {
                this.state.disabled = value;
            } else if (field.toLowerCase() === 'hidden') {
                this.state.hidden = value;
            } else if (field.toLowerCase() === 'align') {
                this.state.align = value;
            } else if (field.toLowerCase() === 'values') {
                var data = [];
                if (Array.isArray(value)) {
                    data = value;
                } else {
                    data = Object.values(value);
                }
                this.state.values = data;
            } else if (field.toLowerCase() === 'headers') {
                if (Array.isArray(value)) {
                    this.state.table_data['thead'] = value;
                } else if (typeof value === 'object') {
                    this.state.table_data['thead'] = Object.values(value);
                }
            } else if (field.toLowerCase() === 'rows') {
                if (Array.isArray(value)) {
                    this.state.table_data['tbody'] = value;
                } else if (typeof value === 'object') {
                    this.state.table_data['tbody'] = Object.values(value);
                }
            } else if (field.toLowerCase() === 'minwords') {
                this.state.minWords= value
            } else if (validPropsJson.some((current, i) => {
                foundMappeableProp = i;
                return current === lowerCaseField;
            })) {
                this.state[validPropsJs[foundMappeableProp]] = value;
            }
        };
    }

    addToResult = (name, value, row) => {
        if (row === -1) {
            this.props.dataResult[name] = value;
        } else {
            this.props.dataResult["TABLE"][row][name] = value;
        }
    }

    isArray = (object) => {
        var value = false;
        if (object instanceof Array) {
            value = true;
        }
        return value;
    }

    counter = 0;
    getCounter = () => {
        return this.counter++;
    }


    getInputForm(mode) {
        switch (mode.toLowerCase()) {
            case "text":
                return null;
            case "textArea":
                return null;
            case "number":
                return null;
            case "autocomplete":
                return null;
            case "radio":
                return <RadioForm data={this.state} required={false} showLabel={this.state.showLabel} rowIndex={this.state.rowIndex} addToResult={this.addToResult} />;
            case "inputcheckbox":
                return <CheckBoxForm data={this.state} required={false} showLabel={this.state.showLabel} rowIndex={this.state.rowIndex} addToResult={this.addToResult} />;
            case "select":
                return <SelectForm data={this.state} required={false} showLabel={this.state.showLabel} rowIndex={this.state.rowIndex} addToResult={this.addToResult} />;
            case "fileUpload":
                return null;
            case "paragraph":
                return null;
            case "header":
                return null;
            case "button":
                return null;
            case "hiddenInput":
                return null;
            case "filter":
                return <SelectSercheableForm data={this.state} required={false} showLabel={this.state.showLabel} rowIndex={this.state.rowIndex} addToResult={this.addToResult} />;
            case "table":
                return <TableForm data={this.state} required={false} addToResult={this.addToResult} dataResult={this.props.dataResult} />;
            case "literal":
                return <LiteralForm data={this.state} showLabel={this.state.showLabel} rowIndex={this.state.rowIndex} addToResult={this.addToResult} />;
            case "inputnumber":
                return <InputNumberForm data={this.state} required={false} showLabel={this.state.showLabel} rowIndex={this.state.rowIndex} addToResult={this.addToResult} />;
            case "inputtext":
                return <InputTextForm data={this.state} required={false} showLabel={this.state.showLabel} rowIndex={this.state.rowIndex} addToResult={this.addToResult} />;
            case "date":
                return <DatePickerForm data={this.state} required={false} showLabel={this.state.showLabel} rowIndex={this.state.rowIndex} addToResult={this.addToResult} />;
            case "textarea":
                return <TextAreaForm data={this.state} required={false} showLabel={this.state.showLabel} rowIndex={this.state.rowIndex} minWords={this.state.minWords} addToResult={this.addToResult}/>;                                
            default:
                return null;
        }
    }

    render() {
        return (
            this.getInputForm(this.state.mode)
        );
    }
}

export default InputForm;